import {
  getItemFromCollection,
} from "directus/src/operations";
import { apiRoot } from "services/src/config";

export async function fetchChannelForDiscord({ id }) {
  try {
    const query = {
      fields: ["id", "channel_id"],
    };
    const response = await getItemFromCollection("integrations_discord", id, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function addChannelAccess(data) {
  try {
    const response = await apiRoot.post(
      "discord/channel/add_access",
      data,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function removeChannelAccess({ channel_id, employee }) {
  try {
    const response = await apiRoot.delete(
      `discord/channel/remove_access?channel_id=${channel_id}&employee=${employee}`,
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
